<template>
    <div class="room-listing__view" :class="{ 'is-loading': loading }">
        <div v-if="hasListings">
            <transition-group name="fade" tag="div" class="row js--faded-hoverContainer">
                <div
                     v-for="(listing, index) in filteredListings"
                     :key="`listing${index}`"
                     class="col-24 col-sm-12 col-md-8 room-listing__listings js--faded-hoverItem"
                     :class="{ 'hover-fadeout-listing' : (!listing.hovered && anyListingsHovered)}">
                    <listing :listing-type="listingsType"
                             :title="listing.title"
                             :url="listing.url"
                             :image="listing.image"
                             :imageAlt="listing.imageAlt ? listing.imageAlt : '' "
                             :category="listing.roomType ? listing.roomType : undefined"
                             :room-view="listing.roomView ? listing.roomView : undefined"
                             :pool-label="listing.hasPoolLabel ? listing.hasPoolLabel : undefined"
                             :occupancy-label="listing.occupancyLabel ? listing.occupancyLabel : undefined"
                             :exploreLabel="listing.callToAction"
                             :dimensions-label="listing.dimensionsLabel ? listing.dimensionsLabel : undefined"
                             :guide-for="listing.guideFor ? listing.guideFor : undefined"
                             :guide-time="listing.guideTime ? listing.guideTime : undefined"
                             :featured="listing.featured"
                             :is-hovered="listing.hovered"
                             :theme="theme">
                    </listing>
                </div>
            </transition-group>
        </div>

        <div v-else class="room-listing__no-results">
            <p>{{ListingNoResultsText}}</p>
        </div>
    </div>
</template>

<script>
    import Listing from './Listing.vue';
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        components: {
            Listing,
        },

        props: ['listingsType', 'theme'],

        created() {
            this.setLoading(true);

            const fetchListings = this.listingsType == 'rooms' ? this.fetchListings() : this.fetchGuides();
            fetchListings
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.setLoading(false);
                        const scrollEvent = new Event('recalculateScroll');
                        window.dispatchEvent(scrollEvent);
                    }, 1000);
                });
        },

        data() {
            return {
                hoverClass: 'js--hover-fade-item',
                hoveredState: false,
                error: null,
            }
        },

        methods: {
            ...mapActions('rooms', ['fetchListings', 'fetchGuides']),

            ...mapMutations('rooms', [
                'setLoading',
            ]),

        },

        computed: {
            ...mapState('rooms', [
                'listings',
                'loading'
            ]),

            ...mapGetters('rooms', [
                'filteredListings',
            ]),

            hasListings() {
                return this.filteredListings.length > 0 || this.loading;
            },

            ListingNoResultsText() {
                return window.ListingNoResultsText;
            },

            anyListingsHovered() {
                return (this.filteredListings.filter(item => item.hovered == true).length > 0);
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>